import login from './login/ar';

export default {
  ...login,
};
